import WellDetails from './WellDetails';

export default WellDetails;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellDetails/index.tsx